import { PaymentStatus } from 'constants/payment';
import { useAppSelector } from 'store/hooks';

import { CheckError } from '../check-error';
import { CheckSuccess } from '../check-success';
import { CheckWait } from '../check-wait';
import { PaymentContainer } from '../payment-container';

const BaseCardWrapperSZ = () => {
  const { paymentData } = useAppSelector((state) => state.payment);
  const renderBaseCard = () => {
    switch (paymentData?.status) {
      case PaymentStatus.WAIT_PAYMENT:
      case PaymentStatus.WAIT_PAYMENT_CONFIRM:
      case PaymentStatus.WAIT_EXTERNAL_PAYSYSTEM:
      case PaymentStatus.WAIT_AMOUNT_CONFIRM:
        return <PaymentContainer />;
      case PaymentStatus.PAYMENT_SUCCESS:
      case PaymentStatus.WAIT_PROCESSING:
        return <CheckSuccess />;
      case PaymentStatus.PAYMENT_FAILED:
      case PaymentStatus.PAYMENT_NOTFOUND:
      case PaymentStatus.INTERNAL_ERROR:
      case PaymentStatus.INVOICE_DISABLED:
      case PaymentStatus.RETRYABLE_FAILED:
      case PaymentStatus.PAYMENT_TIMEOUT:
      case PaymentStatus.INCORRECT_DATA:
      case PaymentStatus.ANTIFROD_DECLINED:
        return <CheckError />;
      case PaymentStatus.HOLDED:
        return <CheckWait />;
      default:
        return <div>Загрузка</div>;
    }
  };

  return renderBaseCard();
};

export { BaseCardWrapperSZ };
